'use strict';

import { view } from '@/functions';

const prefix = '/prohibited-product-reviews';

export default [
    {
        path: prefix,
        name: 'prohibited-product-reviews',
        meta: {
            title: 'Prohibited product reviews',
            scopes: ['read_prohibited_products', 'write_prohibited_products'],
        },
        component: () => view('prohibited-product-reviews/index'),
    },
    {
        path: `${prefix}/info`,
        name: 'prohibited-product-reviews-info',
        meta: {
            title: 'Prohibited product reviews',
            scopes: ['read_prohibited_products', 'write_prohibited_products'],
        },
        component: () => view('prohibited-product-reviews/info'),
    },
];
